import { Box, Button } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import useStylesSettings from '../styles/useStylesSettings.styles';
import ICalendarManagerDialog from './ICalendarManagerV4Dialog';

const ICalendarIntegrationV4 = ({ organizationId }) => {
    const { t } = useTranslation();
    const { classes } = useStylesSettings();

    const [openIntegrationDialog, setOpenIntegrationDialog] = useState(false);

    const handleCloseIntegrationDialog = () => {
        setOpenIntegrationDialog(false);
    };

    return (
        <>
            <div className={classes.pb10px}>
                <Box display="flex" justifyContent="space-between" alignItems="center" style={{ width: '100%' }}>
                    <Box sx={{ display: 'inline-flex' }}>
                        <Button
                            variant="contained"
                            className={classes.redColor}
                            size="small"
                            onClick={() => setOpenIntegrationDialog(true)}
                        >
                            {t('profile.settings.iCalendar.addCalendarIntegration')}
                        </Button>
                    </Box>
                </Box>
            </div>
            <ICalendarManagerDialog 
                openDialog={openIntegrationDialog}
                onCloseDialog={handleCloseIntegrationDialog}
            />
        </>
    );
};

export default ICalendarIntegrationV4;
